import { StyleSheet } from 'react-native';
import { spacing } from '../../shared/theme/spacing'
import { ticketColors, ticketFonts } from '../../shared/theme/ticketColors'
import { typography } from '../../shared/theme/typography';

export const bulkCoefficientModalStyles = StyleSheet.create({
  bulkModalContentNarrow: {
    paddingHorizontal: spacing.md,
  },
  ticketFormBody: {
    gap: 4,
  },
  ticketField: {
    gap: 6,
    marginBottom: 12,
  },
  ticketFieldNested: {
    marginTop: 8,
  },
  ticketFieldLabel: {
    fontSize: 12,
    fontWeight: '600',
    color: ticketColors.ink2,
  },
  ticketInp: {
    height: 40,
    paddingHorizontal: 12,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    fontSize: 14,
    fontWeight: '500',
    color: ticketColors.ink,
  },
  ticketInpRow: {
    flexDirection: 'row',
    alignItems: 'stretch',
    gap: 8,
  },
  ticketInpFlex: {
    flex: 1,
    minWidth: 0,
  },
  ticketScanBtn: {
    width: 40,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    alignItems: 'center',
    justifyContent: 'center',
  },
  ticketScanGlyph: {
    fontSize: 16,
    color: ticketColors.ink2,
  },
  ticketHint: {
    fontSize: 11,
    fontWeight: '500',
    color: ticketColors.ink3,
    lineHeight: 14,
  },
  ticketWarn: {
    fontSize: 11,
    fontWeight: '600',
    color: ticketColors.gold,
    lineHeight: 15,
  },
  previewList: {
    flex: 1,
    minHeight: 0,
  },
  previewListContent: {
    paddingBottom: spacing.md,
  },
  previewSummary: {
    paddingHorizontal: 2,
    paddingBottom: 8,
    gap: 6,
  },
  previewSummaryWarn: {
    fontSize: 11,
    fontWeight: '600',
    color: ticketColors.gold,
    lineHeight: 15,
  },
  previewEmpty: {
    color: ticketColors.ink3,
    fontFamily: ticketFonts.sans,
    fontSize: 13,
    paddingVertical: 16,
    textAlign: 'center',
  },
  previewPager: {
    marginTop: 12,
    paddingTop: 12,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.ruleSoft,
    gap: 10,
  },
  previewPagerMeta: {
    fontSize: 11,
    fontWeight: '600',
    color: ticketColors.ink3,
    textAlign: 'center',
  },
  previewPagerMetaOnly: {
    fontSize: 11,
    fontWeight: '600',
    color: ticketColors.ink3,
    textAlign: 'center',
    marginTop: 12,
    paddingTop: 12,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.ruleSoft,
  },
  previewPagerActions: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
  },
  previewPagerBtn: {
    flex: 1,
    minHeight: 40,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 8,
  },
  previewPagerBtnDisabled: {
    opacity: 0.4,
  },
  previewPagerBtnText: {
    fontSize: 13,
    fontWeight: '700',
    color: ticketColors.ink,
  },
  previewPagerBtnTextDisabled: {
    color: ticketColors.ink3,
  },
  previewPagerIndex: {
    fontSize: 12,
    fontWeight: '700',
    color: ticketColors.ink2,
    minWidth: 52,
    textAlign: 'center',
  },
  previewTableHead: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 10,
    paddingHorizontal: 4,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.rule,
    gap: 12,
  },
  previewThProduct: {
    flex: 1,
    fontSize: 10,
    fontWeight: '700',
    letterSpacing: 0.8,
    textTransform: 'uppercase',
    color: ticketColors.ink3,
  },
  previewThNum: {
    width: 100,
    textAlign: 'right',
    fontSize: 10,
    fontWeight: '700',
    letterSpacing: 0.8,
    textTransform: 'uppercase',
    color: ticketColors.ink3,
  },
  previewRow: {
    paddingVertical: 12,
    paddingHorizontal: 2,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.ruleSoft,
    gap: 6,
  },
  previewName: {
    fontSize: 14,
    fontWeight: '600',
    color: ticketColors.ink,
    lineHeight: 18,
  },
  previewMobileGrid: {
    flexDirection: 'row',
    gap: 10,
    marginTop: 2,
  },
  previewMobileCol: {
    flex: 1,
    minWidth: 0,
    gap: 2,
  },
  previewMobileLabel: {
    fontSize: 10,
    fontWeight: '700',
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    color: ticketColors.ink3,
  },
  previewOld: {
    fontSize: 13,
    fontWeight: '500',
    color: ticketColors.ink2,
    fontVariant: ['tabular-nums'],
  },
  previewArrow: {
    fontSize: 12,
    fontWeight: '600',
    color: ticketColors.ink3,
  },
  previewNew: {
    fontSize: 14,
    fontWeight: '700',
    color: ticketColors.ink,
    fontVariant: ['tabular-nums'],
  },
  previewRowWide: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 4,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.ruleSoft,
    gap: 12,
  },
  previewNameWide: {
    flex: 1,
    minWidth: 0,
    fontSize: 13,
    fontWeight: '500',
    color: ticketColors.ink,
    lineHeight: 17,
  },
  previewOldWide: {
    width: 100,
    textAlign: 'right',
    fontSize: 13,
    fontWeight: '600',
    color: ticketColors.ink2,
    fontVariant: ['tabular-nums'],
  },
  previewNewWide: {
    width: 100,
    textAlign: 'right',
    fontSize: 13,
    fontWeight: '700',
    color: ticketColors.ink,
    fontVariant: ['tabular-nums'],
  },
  // legacy keys kept if referenced elsewhere
  bulkPreviewSection: {
    marginTop: spacing.md,
    paddingTop: spacing.md,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.rule,
  },
  bulkPreviewHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: spacing.sm,
  },
  bulkPreviewTitle: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '700',
  },
  bulkPreviewCount: {
    ...typography.caption,
    color: ticketColors.ink2,
  },
  bulkPreviewTableHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.sm,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.rule,
    gap: spacing.sm,
  },
  bulkPreviewColProduct: {
    flex: 1,
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '700',
    textTransform: 'uppercase',
  },
  bulkPreviewColValue: {
    width: 80,
    textAlign: 'right',
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '700',
    textTransform: 'uppercase',
  },
  bulkPreviewRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.sm,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.rule,
    gap: spacing.sm,
  },
  bulkPreviewProductName: {
    flex: 1,
    ...typography.body,
    color: ticketColors.ink,
  },
  bulkPreviewActual: {
    width: 80,
    textAlign: 'right',
    ...typography.caption,
    color: ticketColors.ink2,
    fontVariant: ['tabular-nums'],
  },
  bulkPreviewNew: {
    width: 80,
    textAlign: 'right',
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '700',
    fontVariant: ['tabular-nums'],
  },
  bulkPreviewMore: {
    ...typography.caption,
    color: ticketColors.ink2,
    marginTop: spacing.sm,
    fontStyle: 'italic',
  },
  bulkPreviewCardNarrow: {
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.sm,
    gap: spacing.xs,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.rule,
  },
  bulkPreviewProductNameNarrow: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '600',
  },
  bulkPreviewNarrowRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: spacing.sm,
  },
  bulkPreviewNarrowLabel: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '600',
  },
  bulkPreviewActualNarrow: {
    ...typography.caption,
    color: ticketColors.ink2,
    flex: 1,
    textAlign: 'right',
    fontVariant: ['tabular-nums'],
  },
  bulkPreviewNewNarrow: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '700',
    fontVariant: ['tabular-nums'],
    flex: 1,
    textAlign: 'right',
  },
});
